import baseTheme from '../baseTheme';
export var MuiAccordionSummary = {
    root: {
        padding: 0,
        flexDirection: 'row-reverse',
        '&$expanded': {
            minHeight: 0,
        },
    },
    content: {
        margin: 'auto',
        fontSize: baseTheme.typography.pxToRem(14),
        color: 'inherit',
        fontWeight: 700,
        textTransform: 'uppercase',
        marginTop: baseTheme.spacing(2),
        marginBottom: baseTheme.spacing(2),
        '&$expanded': {
            marginTop: baseTheme.spacing(2),
            marginBottom: baseTheme.spacing(2),
        },
    },
    expandIcon: {
        padding: baseTheme.spacing(1),
        margin: 0,
        color: 'inherit',
    },
};
//# sourceMappingURL=MuiAccordionSummary.js.map